export const skills = [
    {
        icon: "https://cdn-icons-png.flaticon.com/512/174/174854.png",
        title: "HTML",
        tag: "frontend"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/732/732190.png",
        title: "CSS",
        tag: "frontend"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
        title: "JavaScript",
        tag: "frontend"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
        title: "JavaScript",
        tag: "backend"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/760/760457.png",
        title: "react",
        tag: "frontend"
    },
    
   
    {
        icon: "https://img.icons8.com/fluency/512/node-js.png",
        title: "Node.js",
        tag: "backend"
    },
    {
        icon: "https://img.icons8.com/color/512/nextjs.png",
        title: "Next.js",
        tag: "frontend"
    },
    {
        icon: "https://www.svgrepo.com/show/452093/redux.svg",
        title: "redux",
        tag: "backend"
    },
    {
        icon: "https://img.icons8.com/color/512/mongodb.png",
        title: "MongoDB",
        tag: "backend"
    },
    {
        icon: "https://img.icons8.com/?size=512&id=33039&format=png",
        title: "AWS",
        tag: "backend"
    },
    {
        icon: "https://img.icons8.com/color/512/express-js.png",
        title: "Express.js",
        tag: "backend"
    },
    {
        icon: "https://img.icons8.com/color/512/bootstrap.png",
        title: "Bootstrap",
        tag: "frontend"
    },
    {
        icon: "https://img.icons8.com/ios-glyphs/512/github.png",
        title: "Github",
        tag: "platform"
    },
    {
        icon: "https://i.ibb.co/61nck0S/download-removebg-preview.png",
        title: "VS Code",
        tag: "platform"
    },
    {
        icon: "https://img.icons8.com/color/512/git.png",
        title: "Git",
        tag: "platform"
    },
    {
        icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/New_Replit_Logo.svg/1200px-New_Replit_Logo.svg.png",
        title: "Replit",
        tag: "platform"
    },
    {
        icon: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/512/external-codesandbox-an-online-code-editor-and-sharing-web-application-projects-logo-color-tal-revivo.png",
        title: "Sandbox",
        tag: "platform"
    },
    {
        icon: "https://img.icons8.com/color/512/firebase.png",
        title: "Firebase",
        tag: "platform"
    },
    {
        icon: "https://img.icons8.com/ios-filled/512/codepen.png",
        title: "CodePen",
        tag: "platform"
    },

]

export const projects = [
    {
        id: 1,
        title: "Image-generator",
        type: "Find-Image",
        image: "imagegene.png",
        description: "You can use this website to find any type of image and also you can dowload all the image directly from the original wesite so stay tune",
        techStack: ["HTML", "CSS", "JavaScript"],
        github: "https://github.com/farhahn/Image-Search-Website",
        liveDemo: "https://image-generator-hcht.onrender.com/"
    },
 
   
    {
        id: 2,
        title: "ForeignBazar",
        type: "E-COMMERCE",
        image: "https://user-images.githubusercontent.com/94675329/212765286-55e5183b-598b-4648-96b6-1417b234b1b9.png",
        description: "ForeignBazar is an e-commerce website, where you can take a look on all daily needs like Clothes, Cosmetics etc. And you can go for order them. It's have the admin functionality.",
        techStack: ["React", "CSS", "ReactJS", ],
        liveDemo: "https://foreign-bazar.netlify.app/"
    },
    {
        id: 3,
        title: 'First-AIM',
        type: 'Multi-Player Game',
        image: 'https://github.com/Atanu8250/fast-aim/blob/main/frontend/src/Asset/Images/HomePage.png?raw=true',
        description: 'Fast Aim is a gaming Web-application that allows playing both Single Player and Multi-Player. Try to beat your opponent',
        techStack: ['React',   'Express.js', 'Web-Socket', 'Node.js'],
       
        liveDemo: 'https://fast-aim-game.vercel.app/'
    },
    {
        id: 4,
        title: "GadgetRambo",
        type: "E-COMMERCE",
        image: "https://user-images.githubusercontent.com/94675329/215067790-242b6566-714a-4eaf-b992-63b466f04c08.png",
        description: "GadgetRambo is a technology review, news and e-commerce platform. Here we provided full e-commerce flow and also the admin part.",
        techStack: ["Typescript", "Next.js", "Redux", "CSS", "Firebase", "thunk", "chakra-ui", "MUI"],
       
        liveDemo: "https://gadget-rambo.vercel.app/"
    },
    {
        id: 5,
        title: "YouTube clone",
        type: "OTT PLATFORM",
        image: "https://user-images.githubusercontent.com/94675329/212769255-f619312f-a91f-42cf-8f49-cfde9ef8d282.PNG",
        description: "In this YouTube Clone You can search for any Videos and at the time of watching a video you will get Recommendation also. You can Do Filter by View, Alphabet, Popularity.",
        techStack: ["HTML", "CSS", "JavaScript"],
        
        liveDemo: "https://youtube-cloned-by-atanu.netlify.app/"
    },
    {
        id: 6,
        title: "Neifty PM",
        type: "PROJECT MANAGER",
        image: "https://user-images.githubusercontent.com/94675329/212766385-81cad39c-a83e-4a08-87de-5a539e12ef8d.png",
        description: "Nifty, it's a remote collaboration hub to manage Projects, tasks, communication all in one place. Here you can collaborate with your team within an easy way.",
        techStack: ["HTML", "CSS", "JavaScript"],
        
        liveDemo: "https://nifty-cloned-by-atanu.netlify.app/"
    },
    {
        id: 7,
        title: "Health-Dr.",
        type: "DIET MENTOR",
        image: "https://user-images.githubusercontent.com/94675329/212766892-aa364775-05a3-49c1-acf9-5fb07bb1c5b9.png",
        description: "Health-Dr. website is used to track your health-diet. Here you can set the goal to have a fitness full body and our website will track your fitness and health",
        techStack: ["HTML", "CSS", "JavaScript"],
       
        liveDemo: "https://health-dr-by-team-masai-warriors.netlify.app/"
    }
]